"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionLabel = exports.Section = exports.Queries = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Queries = exports.Queries = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  overflowX: 'auto',
  flexWrap: 'nowrap',
  scrollbarWidth: 'none',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  gap: theme.spacing(3),
  maxWidth: '100%',
  [theme.breakpoints.up('md')]: {
    flexWrap: 'wrap',
    overflowX: 'visible'
  }
}));
const Section = exports.Section = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  withPaddingBottom
}) => ({
  paddingBottom: withPaddingBottom ? theme.spacing(3) : 0,
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(2)
}));
const SectionLabel = exports.SectionLabel = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  textTransform: 'uppercase',
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightBold
}));
//# sourceMappingURL=styles.js.map